export default __webpack_public_path__ + "358c89da4077ba4ebe6e1b72d0ac9b6d.png";